import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { ChatClient, ChatThread, ChatMessageContent } from 'api/clients/ChatClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { reportError } from 'utils/error'
import { chatKeys } from './chatKeys'

export interface Data {
  thread: ChatThread
}

export interface Variables {
  name?: string
  content?: ChatMessageContent[]
  fileId?: string
}

export const createThread = async (workspaceId: number, { name, content, fileId }: Variables) => {
  const response = await ChatClient.createThread(workspaceId, name, content, fileId)

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useCreateThread = () => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<Data, unknown, Variables>(
    'createThread',
    async (variables) => {
      return createThread(workspaceId, variables)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(chatKeys.workspaceThreads(workspaceId))
      },
      onError: (err) => {
        reportError(err, {
          severity: 'error',
        })
      },
    },
  )
}
